module.exports = __webpack_public_path__ + "img/banner.368398b4.webp";